// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-hgiZ","placeholdersHeader":"styles_placeholdersHeader__2U1B0","editorStyle":"styles_editorStyle__16vN-","placeholdersBox":"styles_placeholdersBox__1RqOa"};